'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import UISideNav from 'UIComponents/nav/UISideNav';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Networks } from 'AdsUI/lib/Constants';
import { getDraftsCount } from 'AdsUI/selectors/DraftsSelectors';
import { getAdAccountsByUserAndTeams } from 'AdsUI/selectors/GlobalFilters';
import { getAdAccounts } from 'AdsUI/selectors/AccountsSelectors';
import { hasAccessToRoiReporting, hasUsersAndTeams } from 'AdsUI/selectors/AuthSelectors';

const CampaignsSidebar = ({
  location,
  history,
  draftCount,
  adAccounts,
  hasROIReporting
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UISideNav, {
      value: location.pathname,
      children: [/*#__PURE__*/_jsx(UISideNavItem, {
        value: "/",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.sections.campaigns"
        }),
        onClick: () => history.push('/')
      }), hasROIReporting && /*#__PURE__*/_jsx(UISideNavItem, {
        value: "/sequences",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.sections.sequences"
        }),
        onClick: () => history.push('/sequences')
      }), /*#__PURE__*/_jsx(UISideNavItem, {
        value: "/drafts",
        count: draftCount > 0 && draftCount,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.sections.drafts"
        }),
        onClick: () => history.push('/drafts')
      })]
    }), /*#__PURE__*/_jsx(UISideNav, {
      divider: true,
      children: hasROIReporting && adAccounts && adAccounts.find(adAccount => adAccount.network === Networks.ADWORDS) && /*#__PURE__*/_jsx(UISideNavItem, {
        value: "/recommendations",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.sections.recommendations"
        }),
        onClick: () => history.push('/recommendations')
      })
    })]
  });
};

export default withRouter(connect(state => ({
  draftCount: getDraftsCount(state),
  hasROIReporting: hasAccessToRoiReporting(state),
  adAccounts: hasUsersAndTeams(state) ? getAdAccountsByUserAndTeams(state) : getAdAccounts(state)
}))(CampaignsSidebar));